import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // Import the AuthContext

function Navbar() {
  const { isLoggedIn, logout } = useAuth(); // Use the authentication state and logout function
  const navigate = useNavigate(); // For navigation

  const handleLogout = () => {
    logout(); // Call the logout function from AuthContext
    navigate("/login"); // Redirect to the login page
  };

  return (
    <nav style={styles.navbar}>
      <h1 style={styles.title}>Quiz CMS</h1>
      <ul style={styles.navList}>
        {isLoggedIn && (
          <>
            <li style={styles.navItem}>
              <Link to="/" style={styles.navLink}>Dashboard</Link>
            </li>
            <li style={styles.navItem}>
              <Link to="/create-quiz" style={styles.navLink}>Create Quiz</Link>
            </li>
            <li style={styles.navItem}>
              <Link to="/quizzes" style={styles.navLink}>All Quizzes</Link>
            </li>
            <li style={styles.navItem}>
              <Link to="/questions" style={styles.navLink}>All Questions</Link>
            </li>
            <li style={styles.navItem}>
              <Link to="/categories" style={styles.navLink}>Category List</Link>
            </li>
            <li style={styles.navItem}>
              <Link to="/add-category" style={styles.navLink}>Add Category</Link>
            </li>
           

            {/* <li style={styles.navItem}>
              <Link to="/prize-list" style={styles.navLink}>Prize List</Link>
            </li> */}
            <li style={styles.navItem}>
              <button onClick={handleLogout} style={styles.logoutButton}>
                Logout
              </button>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}

const styles = {
  navbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
  },
  title: {
    margin: 0,
  },
  navList: {
    listStyle: "none",
    display: "flex",
    padding: 0,
    margin: 0,
  },
  navItem: {
    marginLeft: "20px",
  },
  navLink: {
    color: "#fff",
    textDecoration: "none",
    fontWeight: "bold",
  },
  logoutButton: {
    backgroundColor: "transparent",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
    textDecoration: "underline",
  },
};

export default Navbar;
